<!-- 教育局/市监局 -->
<template>
<div class="eAndMsBureau_lyout">
    <carouselView :bannerList="bannerList" :fileUrl="fileBaseUrl"></carouselView>

    <div class="defalut_content eAndMsBureau_lyout_content">
        <div class="eAndMsBureau_lyout_lookUp">
            <customLookupTitle iconfont="icon-zu405-18" title="教育局/市监局-区域校园食品安全监管解决方案"></customLookupTitle>

            <div class="eAndMsBureau_lyout_lookUp_content">
                华略协助主管部门打造区域校园食堂食品安全监管系统平台，从物资采配、食材溯源、食堂监管等多个方面入手，助力构建严密高效、社会共治的食品安全治理体系，减轻监管负担，降低食品安全风险。
            </div>
        </div>

        <div v-for="(item,index) in options" :key="index" class="eAndMsBureau_lyout_options">
            <customOptionsTitle :title="item.title"></customOptionsTitle>
            <pre class="eAndMsBureau_lyout_options_content">{{item.content}}</pre>
        </div>
    </div>
</div>
</template>

<script>
    import carouselView from 'views/generalView/carouselView.vue'
    import customLookupTitle from 'components/custom-lookup/custom-lookup-title.vue'
    import customOptionsTitle from 'components/custom-options-title/custom-options-title.vue'
    import baseView from "views/base/baseView.vue";
    import {mapGetters, mapMutations, mapActions} from 'vuex'
    import dataConfig from "config/solution/eAndMsBureau.data.config.js";
    import metaInfoUtils from 'config/metaInfo.config.js';

    export default {
        extends:baseView,
        metaInfo: metaInfoUtils.currentMetaInfo('/solution/e-ms-bureau'),
        components: {
            carouselView,customLookupTitle,customOptionsTitle
        },
        computed: {
            ...mapGetters(['userInfo']),
        },
        data() {
            return {
                bannerList:dataConfig.bannerList,
                options:dataConfig.options,
            };
        },
        watch:{
           
        },
        created(){
        },
        methods: {
        }
    }
</script>

<style lang="less" scoped>
@import url("./eAndMsBureau.less");
</style>
